// extracted by mini-css-extract-plugin
export default {"container":"Header_container__eqfvs","left":"Header_left__EFYmO","right":"Header_right__BQHgy","item":"Header_item__GPECB","center":"Header_center__a+BkD"};